import { CartAddEvent } from '@theme/events';

let adding = false;

class CksCrossSell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.onSubmit);
  }

  onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-cross-sell-form]')) return;
    event.preventDefault();
    if (adding) return;
    adding = true;
    const button = form.querySelector('button');
    const label = button.textContent;
    const status = this.querySelector('[role="status"]');
    button.disabled = true;
    button.textContent = this.dataset.adding;
    status.textContent = '';
    const sectionIds = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), el => el.dataset.sectionId))].filter(Boolean).slice(0, 5);
    const root = window.Shopify?.routes?.root || '/';
    let succeeded = false;
    try {
      const variantId = new FormData(form).get('id');
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds, sections_url: location.pathname }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.dataset.error);
      succeeded = true;
      button.textContent = this.dataset.added;
      status.textContent = this.dataset.added;
      let cart;
      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) cart = await cartResponse.json();
      } catch {}
      this.dispatchEvent(new CartAddEvent(cart || {}, variantId, {
        source: 'cks-cross-sell', variantId, itemCount: cart?.item_count, sections: result.sections,
      }));
    } catch (error) {
      status.textContent = error.message || this.dataset.error;
    } finally {
      if (!succeeded) {
        button.disabled = false;
        button.textContent = label;
      }
      adding = false;
    }
  };
}

if (!customElements.get('cks-cross-sell')) customElements.define('cks-cross-sell', CksCrossSell);
